import { render, staticRenderFns } from "./auditAnComicCard.vue?vue&type=template&id=28eefe47"
import script from "./auditAnComicCard.vue?vue&type=script&lang=js"
export * from "./auditAnComicCard.vue?vue&type=script&lang=js"
import style0 from "./auditAnComicCard.vue?vue&type=style&index=0&id=28eefe47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports